import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100vw - 8rem)',
    height: 'calc(100% - 2rem)',

    [theme.breakpoints.down('md')]: {
      width: '100vw'
    }
  }
}))

export default useStyles
